// extracted by mini-css-extract-plugin
export var standaloneTable = "_1i-0";
export var standaloneTableWithBodyFill = "_1i-1";
export var withExtraHeader = "_1i-2";